module.exports = __webpack_public_path__ + "static/media/mask.17bdaa1f.svg";